import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";
import { BRAND } from "../data/portfolio";

export default function Pricing() {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" className="relative py-24 md:py-36 scroll-mt-20" data-testid="pricing">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.3em] text-white/40 mb-4">Investment</p>
          <h2 className="font-display font-bold text-4xl md:text-6xl tracking-tight leading-[0.95]">
            Scaled to what the <span className="font-serif-accent italic font-normal">room</span> requires
          </h2>
          <p className="text-white/55 mt-6 max-w-xl">
            A premium keynote or website project is rarely just design. Every engagement is scoped to what the story and the audience actually require, so tell me about yours and I&apos;ll put together a proposal.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#contact"
              onClick={scrollToContact}
              data-testid="pricing-cta"
              className="inline-flex items-center gap-2 rounded-full bg-white text-black px-8 py-4 text-sm font-medium hover:bg-white/85 transition-colors duration-300"
            >
              Start a project <ArrowUpRight size={15} />
            </a>
            <a
              href={`mailto:${BRAND.email}?subject=${encodeURIComponent("Project inquiry")}`}
              data-testid="pricing-email-link"
              className="link-underline text-white/70 hover:text-white text-sm"
            >
              or email me directly
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
